import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/profile`;

export const profileLinks = {
  root: () => base,
  moreSettings: () => `${base}/settings`,
  mentorSettings: () => `${base}/mentorSettings`,
  personalInfo: () => `${base}/personalInfo`,
  accountSettings: () => `${base}/accountSettings`,
  helpAndFeedback: () => `${base}/helpAndFeedback`,
  feedbackForm: () => `${base}/feedback`,
  feedbackConfirmation: () => `${base}/feedbackConfirmation`,
  privacy: () => `${base}/privacy`,
  changeEmail: () => `${base}/email`,
  changePhone: () => `${base}/phone`,
  changePassword: () => `${base}/password`,
  addNewLanguages: () => `${base}/languages/add`,
  editLanguages: (...codes: string[]) => `${base}/languages/${codes.join('/')}`,
  customerSupport: () => `${base}/customerSupport`,
  delete: () => `${base}/delete`,
  guardians: () => `${base}/guardians`,
  guardiansInvitation: () => `${base}/guardiansInvitation`,
};
